<template>
  <v-card>
    <v-card-title class="justify-center">
        <v-btn
            v-if="step !== 1"
            icon
            color="info"
            @click="step = 1, projeto = {}"
        >
            <v-icon>west</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <h1 style="font-size: 1.8em;">
            GERENCIAR PROJETOS FIREBASE
        </h1>
        <v-spacer></v-spacer>
        <v-btn
            v-if="step === 1"
            icon
            color="info"
            @click="step = 2, pegarRedes(), pegarEmpresas(), pegarRedesEmpresa()"
        >
            <v-icon>add</v-icon>
        </v-btn>
        <v-spacer v-else></v-spacer>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
        <v-stepper
            v-model="step"
            class="ma-0 pa-0"
            style="box-shadow: none;"
        >
            <v-stepper-items
                class="ma-0 pa-0"
            >

                <v-stepper-content
                    step="1"
                    class="ma-0 pa-0"
                >
                    <v-data-table
                      :headers="headers"
                      :items="projetos"
                      :loading="loading"
                      :pagination.sync="pagination"
                      :total-items="totalItens"
                      hide-actions
                    >
                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                            <td>
                                {{
                                    props.item.nome_rede ?
                                        `Rede ${props.item.nome_rede}`
                                        :
                                        props.item.empresa ?
                                            `Empresa ${props.item.nome_empresa}`
                                            :
                                            'Não possui'
                                }}
                            </td>
                            <td class="text-xs-left">{{ props.item.codigo }}</td>
                            <td class="text-xs-left">{{ props.item.versao_app }}</td>
                            <td class="text-xs-center">
                                <v-chip small outline :color="props.item.app_bloqueado ? 'error' : 'success'" class="ma-0 font-weight-bold">
                                    <v-icon left small>{{ props.item.app_bloqueado ? 'block' : 'check_circle' }}</v-icon>
                                    {{ props.item.app_bloqueado ? 'Bloqueado' : 'Liberado' }}
                                </v-chip>
                            </td>
                            <td class="text-xs-left">
                                <v-tooltip bottom>
                                    <v-btn
                                        icon
                                        flat
                                        color="info"
                                        slot="activator"
                                        @click="prepararProjeto(props.item)"
                                    >
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <span>Editar Projeto</span>
                                </v-tooltip>
                                <v-menu
                                    offset-x
                                    left
                                    transition="slide-x-reverse-transition"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat color="error" v-on="on">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card
                                        width="30em"
                                        style="
                                            border-radius: 1em;
                                        "
                                    >
                                        <v-card-title class="justify-center">
                                            <h2>Tem certeza que deseja Excluir?</h2>
                                        </v-card-title>
                                        <v-card-actions class="justify-space-around">
                                            <v-btn
                                                round
                                                small
                                            >
                                                Não
                                            </v-btn>
                                            <v-btn
                                                round
                                                small
                                                color="error"
                                                @click="excluirProjetoFirebase(props.item)"
                                            >
                                                Sim
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-menu>
                                <v-tooltip bottom>
                                    <span>Apagar Projeto</span>
                                </v-tooltip>
                            </td>
                        </template>
                    </v-data-table>
                    <div class="text-xs-center pt-2">
                        <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
                    </div>
                </v-stepper-content>
                <v-stepper-content
                    step="2"
                    class="ma-0 pa-0 justify-space-around"
                >
                    <v-alert
                        v-model="alerta.mostrar"
                        :type="alerta.tipo"
                        dismissible
                        class="mb-3"
                    >
                        {{ alerta.mensagem }}
                    </v-alert>
                    <v-form lazy-validation v-model="valido" ref="formulario">
                        <v-layout row wrap class="justify-center mb-3">
                            <v-btn
                                color="info"
                                round
                                outline
                                @click="importarJSON"
                            >
                                <v-icon left>upload</v-icon>
                                Carregar JSON (admin-sdk)
                            </v-btn>
                            <input
                                type="file"
                                ref="fileInput"
                                style="display: none"
                                accept=".json"
                                @change="onFileChange"
                            >
                        </v-layout>
                        <v-autocomplete
                            :items="redes"
                            item-text="nome"
                            item-value="id_rede"
                            v-model="projeto.rede"
                            :disabled="!!projeto.empresa"
                            label="Rede Responsável"
                            clearable
                        >
                        </v-autocomplete>
                        <v-autocomplete
                            :items="redes_empresas"
                            item-text="nome"
                            item-value="id_rede_empresa"
                            v-model="projeto.rede_empresa"
                            :disabled="!!projeto.empresa"
                            label="Rede de Empresa Responsável"
                            clearable
                        >
                        </v-autocomplete>
                        <v-autocomplete
                            :items="empresas"
                            item-text="nome_fantasia"
                            item-value="cnpj"
                            :disabled="!!projeto.rede"
                            v-model="projeto.empresa"
                            label="Empresa Responsável"
                            clearable
                        ></v-autocomplete>
                         <v-text-field
                            v-if="projeto.id"
                            label="Versão do app"
                            v-model="projeto.versao_app"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-card v-if="projeto.id" flat class="pa-3 my-3" style="border: 1px solid #e0e0e0; border-radius: 8px;">
                             <v-switch
                                :input-value="projeto.app_bloqueado"
                                @change="verificarBloqueio"
                                color="error"
                                hide-details
                                class="mt-0 pt-0"
                             >
                                <template slot="label">
                                    <div class="ml-2">
                                        <strong :class="{'error--text': projeto.app_bloqueado}" style="font-size: 1.1em;">
                                            Bloquear Aplicativo
                                        </strong>
                                        <div class="caption grey--text text--darken-1 mt-1">
                                            {{ projeto.app_bloqueado ? 'O aplicativo está totalmente inacessível.' : 'O aplicativo está liberado para uso.' }}
                                        </div>
                                    </div>
                                </template>
                             </v-switch>
                         </v-card>
                         <v-text-field
                            v-if="!projeto.id"
                            label="Project_id"
                            v-model="projeto.project_id"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-text-field
                            v-if="!projeto.id"
                            label="Private_key_id"
                            v-model="projeto.private_key_id"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-text-field
                            v-if="!projeto.id"
                            label="Remetente_id"
                            v-model="projeto.remetente_id"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-textarea
                            v-if="!projeto.id"
                            label="Private_key"
                            v-model="projeto.private_key"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-textarea>
                         <v-text-field
                            v-if="!projeto.id"
                            label="Client_email"
                            v-model="projeto.client_email"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-text-field
                            v-if="!projeto.id"
                            label="Client_id"
                            v-model="projeto.client_id"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-text-field
                            v-if="!projeto.id"
                            label="client_x509_cert_url"
                            v-model="projeto.client_x509_cert_url"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                    </v-form>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-card-text>
    <v-card-actions class="ma-0 pa-0">
        <v-btn
            block
            large
            color="info"
            @click="function () {
                return step === 1 ?
                voltar() :
                projeto.id ?
                editarProjetoFirebase() :
                adicionarProjetoFirebase()
            }"
        >
            <b>
                {{
                    step === 1 ? 'Fechar' : 'Salvar'
                }}
            </b>
        </v-btn>
    </v-card-actions>

    <v-dialog v-model="dialogConfirmarBloqueio" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline error--text">Atenção!</v-card-title>
        <v-card-text>
          Tem certeza que deseja bloquear este aplicativo?
          <br><br>
          <strong>O aplicativo ficará completamente inacessível para todos os usuários.</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="cancelarBloqueio">Cancelar</v-btn>
          <v-btn color="error" flat @click="confirmarBloqueio">Sim, Bloquear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { aesKey, iv } from '@/keys.json'
const CryptoJS = require('crypto-js')
export default {
    data: () => ({
        step: 1,
        pagination: {
            page: 1,
            rowsPerPage: 5
        },
        headers: [
            {
                text: 'Responsável',
                sortable: false,
                align: 'left'
            },
            {
                text: 'Código',
                sortable: false,
                align: 'left'
            },
            {
                text: 'Versão',
                sortable: false,
                align: 'left'
            },
            {
                text: 'Bloqueio',
                sortable: false,
                align: 'center'
            },
            {
                sortable: false,
                align: 'left'
            }
        ],
        projetos: [],
        totalItens: 0,
        projeto: {},
        redes: [],
        empresas: [],
        redes_empresas: [],
        nome_rede: undefined,
        valido: false,
        dialogConfirmarBloqueio: false,
        alerta: {
            mostrar: false,
            tipo: 'success',
            mensagem: ''
        },
        alertaTimeout: null
    }),
    computed: {
        loading () {
            return this.$store.getters.loading
        },
        pages () {
            if (this.pagination.rowsPerPage == null || this.totalItens == null) {
                return 0
            }
            return Math.ceil(this.totalItens / this.pagination.rowsPerPage)
        }
    },
    beforeMount () {
        this.pegarProjetosFirebase()
    },
    watch: {
        'pagination.page' (val) {
            if (val) {
                this.pegarProjetosFirebase()
            }
        }
    },
    methods: {
        voltar () {
            if (this.step === 1) this.$emit('fechar')
            else this.step = 1
        },
        verificarBloqueio (val) {
            if (val) {
                this.dialogConfirmarBloqueio = true
            } else {
                this.$set(this.projeto, 'app_bloqueado', false)
                this.salvarBloqueioImediato(false)
            }
        },
        confirmarBloqueio () {
            this.$set(this.projeto, 'app_bloqueado', true)
            this.dialogConfirmarBloqueio = false
            this.salvarBloqueioImediato(true)
        },
        cancelarBloqueio () {
            this.$set(this.projeto, 'app_bloqueado', false)
            this.dialogConfirmarBloqueio = false
        },
        mostrarAlerta (tipo, mensagem) {
            this.alerta = {
                mostrar: true,
                tipo,
                mensagem
            }
            if (this.alertaTimeout) {
                clearTimeout(this.alertaTimeout)
            }
            this.alertaTimeout = setTimeout(() => {
                this.alerta.mostrar = false
            }, 4000)
        },
        salvarBloqueioImediato (estado) {
            this.$store.dispatch('projetosFirebase', {
                method: 'PATCH',
                id: this.projeto.id,
                body: {
                    app_bloqueado: estado
                }
            }).then(() => {
                this.pegarProjetosFirebase()
                this.mostrarAlerta('success', estado ? 'Aplicativo bloqueado com sucesso!' : 'Aplicativo desbloqueado com sucesso!')
            }).catch(() => {
                this.$set(this.projeto, 'app_bloqueado', !estado)
                this.mostrarAlerta('error', 'Não foi possível alterar o bloqueio. Por favor, tente novamente.')
            })
        },
        importarJSON () {
            this.$refs.fileInput.click()
        },
        onFileChange (e) {
            const files = e.target.files
            if (files.length === 0) return

            const file = files[0]
            const reader = new FileReader()

            reader.onload = (event) => {
                try {
                    const json = JSON.parse(event.target.result)

                    // Mapeamento dos campos do JSON para o objeto projeto
                    this.projeto = {
                        ...this.projeto,
                        project_id: json.project_id || '',
                        private_key_id: json.private_key_id || '',
                        private_key: json.private_key || '',
                        client_email: json.client_email || '',
                        client_id: json.client_id || '',
                        remetente_id: json.remetente_id || '',
                        client_x509_cert_url: json.client_x509_cert_url || ''
                    }

                    // Se não houver remetente_id no JSON, talvez o usuário queira preencher manualmente.
                    // O Vuetify v-text-field vai refletir as mudanças automaticamente.

                    this.$store.commit('set_snackbar', {
                        text: 'Campos preenchidos com sucesso!',
                        color: 'success'
                    })
                } catch (error) {
                    console.error('Erro ao ler o arquivo JSON:', error)
                    this.$store.commit('set_snackbar', {
                        text: 'Erro ao processar o arquivo JSON. Verifique o formato.',
                        color: 'error'
                    })
                } finally {
                    // Resetar o input para permitir selecionar o mesmo arquivo novamente se necessário
                    this.$refs.fileInput.value = ''
                }
            }

            reader.readAsText(file)
        },
        prepararProjeto (projeto) {
            this.pegarRedes(projeto.rede)
            this.pegarRedesEmpresa(projeto.rede_empresa)
            this.pegarEmpresas(projeto.empresa)
            this.projeto = { ...projeto }
            this.step = 2
        },
        adicionarProjetoFirebase () {
            if (this.$refs.formulario.validate()) {
                var ciphertext = CryptoJS.AES.encrypt(JSON.stringify({
                    project_id: this.projeto.project_id.trim(),
                    private_key_id: this.projeto.private_key_id.trim(),
                    remetente_id: this.projeto.remetente_id.trim(),
                    private_key: this.projeto.private_key.trim(),
                    client_email: this.projeto.client_email.trim(),
                    client_id: this.projeto.client_id.trim(),
                    client_x509_cert_url: this.projeto.client_x509_cert_url.trim(),
                    rede: this.projeto.rede,
                    rede_empresa: this.projeto.rede_empresa,
                    empresa: this.projeto.empresa
                }),
                    CryptoJS.enc.Utf8.parse(aesKey),
                    {
                    iv: CryptoJS.enc.Utf8.parse(iv),
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                    }).toString()
                this.$store.dispatch('projetosFirebase', {
                    method: 'POST',
                    body: {
                        projeto_criptografado: ciphertext
                    }
                }).then(() => {
                    this.pegarProjetosFirebase()
                    this.voltar()
                })
            } else {
                console.error('Fumulário inválido')
            }
        },
        excluirProjetoFirebase (projeto) {
            this.$store.dispatch('projetosFirebase', {
                method: 'DELETE',
                id: projeto.id
            }).then(() => {
                this.pegarProjetosFirebase()
            })
        },
        editarProjetoFirebase () {
            this.$store.dispatch('projetosFirebase', {
                method: 'PATCH',
                id: this.projeto.id,
                body: {
                    versao_app: this.projeto.versao_app,
                    app_bloqueado: this.projeto.app_bloqueado,
                    rede: this.projeto.rede,
                    rede_empresa: this.projeto.rede_empresa,
                    empresa: this.projeto.empresa
                }
            }).then(() => {
                this.pegarProjetosFirebase()
                this.voltar()
            })
        },
        pegarProjetosFirebase () {
            this.$store.dispatch('projetosFirebase', {
                method: 'GET',
                body: {
                    page: this.pagination.page
                }
            }).then(json => {
                this.projetos = json.results
                this.totalItens = json.count
            })
        },
        pegarRedes (idRede = undefined) {
            const data = {}
            if (idRede) data.rede = idRede
            if (this.nome_rede) data.nome__icontains = this.nome_rede
            this.$store.dispatch('pegarTodasRedes', data).then(json => {
                this.redes = json
            })
        },
        pegarRedesEmpresa (idRedeEmpresa = undefined) {
            const data = {}
            if (idRedeEmpresa) data.rede = idRedeEmpresa
            if (this.nome_rede) data.nome__icontains = this.nome_rede
            data.ativo = typeof this.ativoFiltro !== 'undefined' ? this.ativoFiltro : true
            this.$store.dispatch('pegarTodasRedesEmpresas', data)
              .then(json => {
                this.redes_empresas = Array.isArray(json) ? json : (json.results || json)
              })
              .catch(() => {
                this.redes_empresas = []
              })
        },
        pegarEmpresas (idEmpresa = undefined) {
            const data = {
                ativo: true
            }
            if (idEmpresa) data.cnpj = idEmpresa
            this.$store.dispatch('procurarEmpresasPorAdm', { filtros: data }).then(json => {
                this.empresas = json
            })
        }
    }
}
</script>

<style>

</style>
